import { Product } from '../../../../shared/infrastructure/types/common/common-types';

enum StorageKey {
  SKOROZVON_LAST_USER = 'skorozvon_last_user',
  SKIP_CONNECT_TO_WEBRTC = 'skipConnectToWebrtc',
}

interface IAppLoaderStorage {
  authToken?: AccessTokenBody;
  apiUrl?: Url;
  apiHost?: Host;
  apiProtocol?: Protocol;
  shardUrls?: Url[];
  supremeUrl?: Url;
  phoneBusUrl?: Url;
  originDomain: Url;
  product?: Product;
  domain: Host;
  addEntry<T>(key: StorageKey, value: T);
  clearEntry(key: StorageKey);
  getEntry(key: StorageKey);
}

export { type IAppLoaderStorage, StorageKey };
